var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconListUser = function SvgIconListUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1793 18.5293H11.21V22.0254H22.1793C22.8795 22.0254 23.3462 21.5593 23.3462 20.86V19.6947C23.3462 19.112 22.7628 18.5293 22.1793 18.5293Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1793 14.2168H11.21V17.7129H22.1793C22.8795 17.7129 23.3462 17.2468 23.3462 16.5475V15.3822C23.3462 14.7995 22.7628 14.2168 22.1793 14.2168Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1793 10.0215H11.21V13.5176H22.1793C22.8795 13.5176 23.3462 13.0515 23.3462 12.3522V11.1869C23.3462 10.4876 22.7628 10.0215 22.1793 10.0215Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1793 5.70996H11.21V9.20608H22.1793C22.8795 9.20608 23.3462 8.73993 23.3462 8.04071V6.87533C23.3462 6.17611 22.7628 5.70996 22.1793 5.70996Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0124 7.57456V20.3937C21.0124 22.0252 19.7287 23.3071 18.095 23.3071H7.59242C5.95869 23.3071 4.67505 22.0252 4.67505 20.3937V7.57456C4.67505 5.94304 5.95869 4.66113 7.59242 4.66113H18.095C19.612 4.66113 21.0124 5.94304 21.0124 7.57456Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0124 7.57456V20.3937C21.0124 22.0252 19.7287 23.3071 18.095 23.3071H8.75942C7.12569 23.3071 5.84204 22.0252 5.84204 20.3937V7.57456C5.84204 5.94304 7.12569 4.66113 8.75942 4.66113H17.9783C19.6121 4.66113 21.0124 5.94304 21.0124 7.57456Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40917 19.8109C8.29248 19.8109 8.17578 19.6944 8.17578 19.5779V19.3448C8.17578 18.6456 8.52587 18.0629 9.10934 17.7133L10.8598 16.6644C11.0932 16.5479 11.3265 16.1983 11.3265 15.9652V15.1495L11.2099 15.0329C10.7431 14.6833 10.5097 14.1006 10.2763 13.5179V13.4014H10.1596C10.0429 13.2849 9.92621 13.1683 9.92621 12.9353V12.003C9.92621 11.8864 10.0429 11.6533 10.1596 11.5368L10.2763 11.4203V10.2549C10.2763 10.1384 10.393 8.15723 12.8436 8.15723C15.2942 8.15723 15.4109 10.1384 15.4109 10.2549V11.5368L15.5276 11.6533C15.6443 11.6533 15.6443 11.8864 15.6443 12.003V12.9353C15.6443 13.1683 15.5276 13.2849 15.4109 13.4014H15.2942V13.5179C15.1775 14.1006 14.8274 14.6833 14.4773 15.0329L14.3606 15.1495V15.9652C14.3606 16.3148 14.4773 16.5479 14.8274 16.6644L16.5778 17.7133C17.1613 18.0629 17.5114 18.6456 17.5114 19.3448V19.5779C17.5114 19.6944 17.3947 19.8109 17.278 19.8109H8.40917V19.8109Z",
    fill: "url(#paint6_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1.99268,
    y: -1,
    width: 32.0068,
    height: 31.9689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.0637,
    y1: 20.1325,
    x2: 27.8328,
    y2: 19.8997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.0486,
    y1: 15.8524,
    x2: 24.8223,
    y2: 16.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.3376,
    y1: 11.1964,
    x2: 23.2827,
    y2: 10.7567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.2381,
    y1: 7.43063,
    x2: 27.7476,
    y2: 7.50822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2884A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.9613,
    y1: 5.5157,
    x2: 6.96025,
    y2: 20.9753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 13.1651,
    y1: 1.20965,
    x2: 13.5892,
    y2: 22.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 16.0025,
    y1: 10.0062,
    x2: 10.3664,
    y2: 22.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6712,
    height: 18.646,
    fill: "white",
    transform: "translate(4.67505 4.66113)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconListUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconListUser.6166aec3.svg";
export { ForwardRef as ReactComponent };